module.exports = __webpack_public_path__ + "img/exclamation_mark_icon.c33de69c.svg";